(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/play/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/lotto/components/play/assets/javascripts/prescript.js');

'use strict';

svs.lotto = svs.lotto || {};
svs.lotto.components = svs.lotto.components || {};
svs.lotto.components.play = svs.lotto.components.play || {};
svs.lotto.components.play.behaviors = svs.lotto.components.play.behaviors || {};
svs.lotto.components.play.views = svs.lotto.components.play.views || {};

 })(window);